import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';

function isImageDoc(doc) {
  const type = String(doc?.file_type || '').toLowerCase();
  const name = String(doc?.original_name || doc?.url || '').toLowerCase();
  return type.startsWith('image/') || /\.(jpe?g|png|gif|webp)$/.test(name);
}

export function collectAssessmentDocuments(assessment) {
  if (!assessment) return [];
  if (Array.isArray(assessment.documents) && assessment.documents.length > 0) {
    return assessment.documents.filter((doc) => doc?.url);
  }
  if (assessment.document_url) {
    return [{
      url: assessment.document_url,
      original_name: 'Document',
      file_type: null,
    }];
  }
  return [];
}

const AssessmentDocumentsBlock = ({ assessment, title = 'Documents', embedded = false }) => {
  const docs = collectAssessmentDocuments(assessment);
  const wrapClass = embedded ? '' : 'border-t border-gray-200 pt-4';

  if (docs.length === 0) {
    if (!assessment?.document_file_path) return null;
    return (
      <div className={wrapClass}>
        {title ? <h4 className="text-sm font-semibold text-gray-700 mb-2">{title}</h4> : null}
        <p className="text-sm text-gray-500">A document is saved, but the preview link is unavailable. Try again in a moment.</p>
      </div>
    );
  }

  return (
    <div className={wrapClass}>
      {title ? <h4 className="text-sm font-semibold text-gray-700 mb-3">{title}</h4> : null}
      <ul className="space-y-3">
        {docs.map((doc, index) => (
          <li
            key={`${doc.id || doc.url || doc.original_name}-${index}`}
            className="rounded-lg border border-gray-200 p-3"
          >
            {isImageDoc(doc) ? (
              <a href={doc.url} target="_blank" rel="noopener noreferrer" className="block">
                <img
                  src={doc.url}
                  alt={doc.original_name || 'Assessment image'}
                  className="mb-2 max-h-56 w-full rounded-md object-contain bg-gray-50"
                />
              </a>
            ) : null}
            <div className="flex items-center justify-between gap-2">
              <span className="truncate text-sm text-gray-800">
                {doc.original_name || `Document ${index + 1}`}
              </span>
              <a
                href={doc.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-primary-300 px-3 py-1.5 text-sm text-primary-600 hover:bg-primary-50"
              >
                <HiOutlineDocumentText className="h-4 w-4" />
                View
              </a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AssessmentDocumentsBlock;
